/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { GlaeubigerSchuldnerIdsResponseMeta } from '../model/models';
import { GlaeubigerSchuldnerResponseMeta } from '../model/models';
import { LoadPfandrechtSichtGrundstueckResponseMeta } from '../model/models';
import { PfandrechtMasterDetailEntryMeta } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class GbpfandrechtService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param erid 
     * @param timepoint 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadPfandrechtByEreid(erid?: string, timepoint?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PfandrechtMasterDetailEntryMeta>;
    public loadPfandrechtByEreid(erid?: string, timepoint?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PfandrechtMasterDetailEntryMeta>>;
    public loadPfandrechtByEreid(erid?: string, timepoint?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PfandrechtMasterDetailEntryMeta>>;
    public loadPfandrechtByEreid(erid?: string, timepoint?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (erid !== undefined && erid !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>erid, 'erid');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PfandrechtMasterDetailEntryMeta>(`${this.configuration.basePath}/gb/pfandrecht`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param masterId 
     * @param historisiert 
     * @param versionId 
     * @param timepoint 
     * @param timepointId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadPfandrechtById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PfandrechtMasterDetailEntryMeta>;
    public loadPfandrechtById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PfandrechtMasterDetailEntryMeta>>;
    public loadPfandrechtById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PfandrechtMasterDetailEntryMeta>>;
    public loadPfandrechtById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (masterId === null || masterId === undefined) {
            throw new Error('Required parameter masterId was null or undefined when calling loadPfandrechtById.');
        }
        if (historisiert === null || historisiert === undefined) {
            throw new Error('Required parameter historisiert was null or undefined when calling loadPfandrechtById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (versionId !== undefined && versionId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>versionId, 'versionId');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PfandrechtMasterDetailEntryMeta>(`${this.configuration.basePath}/gb/pfandrecht/${encodeURIComponent(String(masterId))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param personstammMasterId 
     * @param sicht 
     * @param timepoint 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadPfandrechtIdsSichtPersonstamm(personstammMasterId: string, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlaeubigerSchuldnerIdsResponseMeta>;
    public loadPfandrechtIdsSichtPersonstamm(personstammMasterId: string, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlaeubigerSchuldnerIdsResponseMeta>>;
    public loadPfandrechtIdsSichtPersonstamm(personstammMasterId: string, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlaeubigerSchuldnerIdsResponseMeta>>;
    public loadPfandrechtIdsSichtPersonstamm(personstammMasterId: string, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (personstammMasterId === null || personstammMasterId === undefined) {
            throw new Error('Required parameter personstammMasterId was null or undefined when calling loadPfandrechtIdsSichtPersonstamm.');
        }
        if (sicht === null || sicht === undefined) {
            throw new Error('Required parameter sicht was null or undefined when calling loadPfandrechtIdsSichtPersonstamm.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (personstammMasterId !== undefined && personstammMasterId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>personstammMasterId, 'personstammMasterId');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }
        if (sicht !== undefined && sicht !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sicht, 'Sicht');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlaeubigerSchuldnerIdsResponseMeta>(`${this.configuration.basePath}/gb/pfandrecht/sicht/personstamm/id`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundstueckIds 
     * @param historisiert 
     * @param rangregelungen 
     * @param timepoint 
     * @param timepointId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadPfandrechtSichtGrundstueck(grundstueckIds: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', rangregelungen?: boolean, timepoint?: string, timepointId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadPfandrechtSichtGrundstueckResponseMeta>;
    public loadPfandrechtSichtGrundstueck(grundstueckIds: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', rangregelungen?: boolean, timepoint?: string, timepointId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadPfandrechtSichtGrundstueckResponseMeta>>;
    public loadPfandrechtSichtGrundstueck(grundstueckIds: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', rangregelungen?: boolean, timepoint?: string, timepointId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadPfandrechtSichtGrundstueckResponseMeta>>;
    public loadPfandrechtSichtGrundstueck(grundstueckIds: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', rangregelungen?: boolean, timepoint?: string, timepointId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (grundstueckIds === null || grundstueckIds === undefined) {
            throw new Error('Required parameter grundstueckIds was null or undefined when calling loadPfandrechtSichtGrundstueck.');
        }
        if (historisiert === null || historisiert === undefined) {
            throw new Error('Required parameter historisiert was null or undefined when calling loadPfandrechtSichtGrundstueck.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckIds !== undefined && grundstueckIds !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>grundstueckIds, 'grundstueckIds');
        }
        if (rangregelungen !== undefined && rangregelungen !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>rangregelungen, 'rangregelungen');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadPfandrechtSichtGrundstueckResponseMeta>(`${this.configuration.basePath}/gb/pfandrecht/sicht/grundstueck`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param personstammMasterId 
     * @param glaeubigerMasterIds 
     * @param schuldnerMasterIds 
     * @param sicht 
     * @param timepoint 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadPfandrechtSichtPersonstamm(personstammMasterId: string, glaeubigerMasterIds: Array<string>, schuldnerMasterIds: Array<string>, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GlaeubigerSchuldnerResponseMeta>;
    public loadPfandrechtSichtPersonstamm(personstammMasterId: string, glaeubigerMasterIds: Array<string>, schuldnerMasterIds: Array<string>, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GlaeubigerSchuldnerResponseMeta>>;
    public loadPfandrechtSichtPersonstamm(personstammMasterId: string, glaeubigerMasterIds: Array<string>, schuldnerMasterIds: Array<string>, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GlaeubigerSchuldnerResponseMeta>>;
    public loadPfandrechtSichtPersonstamm(personstammMasterId: string, glaeubigerMasterIds: Array<string>, schuldnerMasterIds: Array<string>, sicht: 'GLAEUBIGER' | 'SCHULDNER' | 'BOTH', timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (personstammMasterId === null || personstammMasterId === undefined) {
            throw new Error('Required parameter personstammMasterId was null or undefined when calling loadPfandrechtSichtPersonstamm.');
        }
        if (glaeubigerMasterIds === null || glaeubigerMasterIds === undefined) {
            throw new Error('Required parameter glaeubigerMasterIds was null or undefined when calling loadPfandrechtSichtPersonstamm.');
        }
        if (schuldnerMasterIds === null || schuldnerMasterIds === undefined) {
            throw new Error('Required parameter schuldnerMasterIds was null or undefined when calling loadPfandrechtSichtPersonstamm.');
        }
        if (sicht === null || sicht === undefined) {
            throw new Error('Required parameter sicht was null or undefined when calling loadPfandrechtSichtPersonstamm.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (personstammMasterId !== undefined && personstammMasterId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>personstammMasterId, 'personstammMasterId');
        }
        if (glaeubigerMasterIds) {
            glaeubigerMasterIds.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'glaeubigerMasterIds');
            })
        }
        if (schuldnerMasterIds) {
            schuldnerMasterIds.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'schuldnerMasterIds');
            })
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }
        if (sicht !== undefined && sicht !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sicht, 'Sicht');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GlaeubigerSchuldnerResponseMeta>(`${this.configuration.basePath}/gb/pfandrecht/sicht/personstamm`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
